import { BtnActions, ViewErrors } from "../Types";


export const tenantInformationErrors: ViewErrors = {
  IDENTITY_DOCUMENT_NOT_AVAILABLE: {
    title: 'Tu documento está asociado a otra cuenta',
    text: 'Por favor, revisa la información del documento que ingresaste.',
    textSecondary: 'El documento que ingresaste está vinculado al número {0}. Si lo reconoces, inicia sesión con ese número para completar tu aplicación.',
    btnText: 'Aceptar',
    btnAction: BtnActions.KEEP_ON_PAGE,
  },
  DEFAULT: {
    title: 'Tuvimos un error inesperado',
    text: 'Algo ocurrió al intentar procesar tu información. Por favor intenta de nuevo.',
    btnText: 'Aceptar',
    btnAction: BtnActions.KEEP_ON_PAGE,
  }
};

export const cotenantInformationErrors: ViewErrors = {
  IDENTITY_DOCUMENT_NOT_AVAILABLE: {
    title: 'Tu documento está asociado a otra cuenta',
    text: 'Recuerda que como coarrendatario, debes ingresar tu propio documento para completar la aplicación.',
    textSecondary: 'El documento que ingresaste está vinculado al número {0}. Si lo reconoces, inicia sesión con ese número para completar tu aplicación.',
    btnText: 'Aceptar',
    btnAction: BtnActions.KEEP_ON_PAGE,
  },
  DEFAULT: {
    title: 'Tuvimos un error inesperado',
    text: 'Algo ocurrió al intentar procesar tu información. Por favor intenta de nuevo.',
    btnText: 'Aceptar',
    btnAction: BtnActions.KEEP_ON_PAGE,
  }
};
